/**
 * dateLocal.js — datum kao KALENDARSKI DAN u lokalnoj zoni (Europe/Zagreb).
 *
 * ZAŠTO POSTOJI: `d.toISOString().slice(0,10)` vraća datum u UTC-u. U Hrvatskoj je
 * lokalna ponoć 22:00 (ljeti) ili 23:00 (zimi) PRETHODNOG dana u UTC-u, pa se svaki
 * ovako formatiran datum pomakne DAN UNATRAG. Posljedice koje su bile u produkciji:
 *   • Statistika · Ugovori: "Rujan 2026" slao je backendu raspon 31.08.–29.09., pa su
 *     ugovori potpisani 31.08. (DELIĆ 25 mjesta, FiSto-Mont 2) upadali u rujan, a 30.09. ispadao.
 *   • Tjedni graf aktivnosti: ključ tjedna bio je nedjelja umjesto ponedjeljka → graf uvijek prazan.
 *   • Zadano "danas" u poljima za datum: između 00:00 i 02:00 nudilo je jučerašnji datum.
 *
 * PRAVILO: za KALENDARSKI DAN (raspon izvještaja, datum u formi, ključ dana/tjedna)
 * koristi isoLocal/todayISO. `toISOString()` koristi samo za pravi TRENUTAK (timestamp).
 */

/** Date → "YYYY-MM-DD" po LOKALNOJ zoni (bez UTC pomaka). */
export const isoLocal = (d) => {
  const x = d instanceof Date ? d : new Date(d);
  return `${x.getFullYear()}-${String(x.getMonth() + 1).padStart(2, '0')}-${String(x.getDate()).padStart(2, '0')}`;
};

/** Današnji kalendarski dan, lokalno. */
export const todayISO = () => isoLocal(new Date());

/** "YYYY-MM-DD" → Date u lokalnoj ponoći (bez UTC parsiranja koje pomakne dan). */
export const parseLocal = (s) => {
  const [y, m, d] = String(s).split('-').map(Number);
  return new Date(y, (m || 1) - 1, d || 1);
};

/** Pomak za N dana nad "YYYY-MM-DD", ostaje lokalno. */
export const shiftISO = (s, delta) => {
  const d = parseLocal(s);
  d.setDate(d.getDate() + delta);
  return isoLocal(d);
};
